// extracted by mini-css-extract-plugin
module.exports = {"TextBanner":"TextBanner_TextBanner__R8gaJ"};